import { Quote } from '../models/quote';
import { emptyPrice } from './empty-price';

export const emptyQuote: Quote = {
    id: null,
    courier: '',
    courierName: '',
    serviceId: '',
    serviceName: '',
    serviceLogo: '',
    provisionId: null,
    cost: emptyPrice,
    customer: emptyPrice,
    reseller: emptyPrice,
    list: emptyPrice,
    listCurrencyConversion: 1,
    discountPercent: null,
    estimatedDeliveryDate: null,
    estimatedDeliveryTime: null,
    notes: []
};
